// @ts-check
import React from "react"
import { TableBodyLoading } from "./TableBodyLoading.component"
import { TableBodyEmpty } from "./TableBodyEmpty.component"
import { TableBodyVirtual } from "./TableBodyVirtual.component"

/**
 * @param {import("./TableBody.component.types").TableBodyProps} props
 */
export const TableBody = (props) => {
  const {
    table,
    tableRef,
    estimateSize,
    isLoading = false,
    isEmpty,
    emptyMessage,
    enableStickyGroupHeaders,
    getIsRowSticky,
    onContextMenu,
    rowClassName,
    infiniteScroll,
  } = props

  if ((isLoading && isEmpty) || (isLoading && infiniteScroll === undefined)) {
    return <TableBodyLoading table={table} />
  }

  if (isEmpty) {
    return <TableBodyEmpty table={table} emptyMessage={emptyMessage} />
  }

  return (
    <TableBodyVirtual
      table={table}
      tableRef={tableRef}
      estimateSize={estimateSize}
      enableStickyGroupHeaders={enableStickyGroupHeaders}
      getIsRowSticky={getIsRowSticky}
      onContextMenu={onContextMenu}
      rowClassName={rowClassName}
      infiniteScroll={infiniteScroll}
    />
  )
}
